export const EmptyIcon = ({ width, height }: { width: number; height: number }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 53 51"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.1886 42.3965L26.4917 36.2277L36.7948 42.4621L34.0386 30.7809L43.0948 22.9059L31.1511 21.8559L26.4917 10.8309L21.8323 21.7902L9.88857 22.8402L18.9448 30.7152L16.1886 42.3965ZM10.2823 50.5996L14.5479 32.159L0.241699 19.7559L19.1417 18.1152L26.4917 0.724609L33.8417 18.1152L52.7417 19.7559L38.4354 32.159L42.7011 50.5996L26.4917 40.8215L10.2823 50.5996Z"
      fill="#E2B640"
    />
  </svg>
);
